import React, {FC, useContext, useMemo} from 'react';
import {EdgeProps, getBezierPath, EdgeLabelRenderer, BaseEdge, getSmoothStepPath, useNodes, Node} from 'reactflow';
import Chip from "@mui/material/Chip";
import {sentenceCase} from "change-case";
import {
  CheckCircle, Close, DoNotDisturb, ErrorRounded,
  HourglassBottomRounded,
  HourglassTopRounded,
  SignalWifiStatusbarConnectedNoInternet4Rounded, WarningRounded
} from "@mui/icons-material";
import {EditorContext} from "./context";
import {IconButton} from "@mui/material";

const AssetConnectionEdge: FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  source,
  target,
  sourceHandleId,
  targetHandleId,
  sourcePosition,
  targetPosition,
  data,
  ...props
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const nodes = useNodes();
  const {updateData} = useContext(EditorContext);

  const connectedNode: Node | undefined = useMemo(() => {
    return nodes.find((node: Node) => node.id === target);
  }, [nodes]);

  const connectedService: any = useMemo(() => {
    return connectedNode?.data.options?.find((option: any) => targetHandleId?.startsWith(option.id));
  }, [connectedNode]);

  let status = connectedNode?.data.enabled && connectedService?.enabled;
  let icon = <HourglassTopRounded color={'warning'} />
  let color: "default" | "error" | "success" | "warning" | "info" | "primary" | "secondary" | undefined = 'primary';
  if(status) {
    color = 'success';
    icon = <CheckCircle color={'success'}/>
  } else {
    color = 'error';
    icon = <DoNotDisturb color={'error'} />
  }

  return (
    <>
      <BaseEdge id={id} path={edgePath} />
      <EdgeLabelRenderer>
        <div style={{position: 'absolute', transform: `translate(-50%, -50%) translate(${targetX-30}px,${targetY}px)`, pointerEvents: 'all',}}>
          <IconButton onClick={() => {
            updateData({
              force_update_id: connectedNode?.id,
              options: [...connectedNode?.data.options.map((option: any) => {
                if(targetHandleId?.startsWith(option.id)) {
                  option.enabled = !option.enabled;
                }
                return option;
              })]
            });
          }}>{icon}</IconButton>
        </div>
        {/*<Chip label={status} sx={{*/}
        {/*  textTransform: 'capitalize',*/}
        {/*  position: 'absolute',*/}
        {/*  transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,*/}
        {/*  borderRadius: '20px',*/}
        {/*  padding: '4px 8px !important',*/}
        {/*  fontSize: '16px',*/}
        {/*  fontWeight: '400',*/}
        {/*  lineHeight: '21px',*/}
        {/*}} size={'small'} variant="filled" color={color} />*/}
      </EdgeLabelRenderer>
    </>
  );
};

export default AssetConnectionEdge;